import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";

import { Col, Icon, Row, Table } from "antd";

import { Creators as AppActions } from "../../../store/ducks/app";

import { getAnimalBirthsImportLog } from "../../../services/importService";

import { CardCustom, Title } from "./styles";

import ButtonStandard from "../../../components/utils/button";
import EyeIcon from "../../../components/utils/icons/eye";
import TagStatus from "../../../components/utils/tagStatus";
import useModuleContext from "../../../hooks/useModuleContext";

function AnimalBirthImport() {
  const Column = Table.Column;

  const [importAnimalBirthLogData, setImportAnimalBirthLogData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // const [importLogId, setImportLogId] = useState(null);
  // const [canDeleteFile, setCanDeleteFile] = useState(false);

  const { isAllowedFunctions } = useModuleContext();

  const {
    translation,
    groupSelected: { id: groupId },
    farmSelected: { id: farmId },
  } = useSelector((state) => state.app);

  const dispatch = useDispatch();

  const fetchData = useCallback(
    async (page = 0, sorter = {}, filters = "", size = 10) => {
      setIsLoading(true);
      try {
        const {
          data: { results: responseAnimalBirthImports },
        } = await getAnimalBirthsImportLog({
          groupId,
          farmId,
          page,
          sorter,
          filters,
          size,
        });
        setImportAnimalBirthLogData(responseAnimalBirthImports);
      } catch (error) {
        console.error(error);
        setImportAnimalBirthLogData(null);
      } finally {
        setIsLoading(false);
      }
    },
    [groupId, farmId]
  );

  const handleReloadTable = async () => {
    fetchData();
  };

  const handleTableChange = async (pagination, filters, sorter) => {
    let search = "";

    fetchData(pagination.current, sorter, search, pagination.pageSize);
  };

  // const confirmDelete = async (importFileRequestId) => {};

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <CardCustom>
      <Row type="flex" justify="space-between" className="rowHeader">
        <Col>
          <Title>{translation.imports.animalBirths.table.title}</Title>
        </Col>
        <Col>
          <ButtonStandard
            buttonType="typeWithoutBackground"
            onClick={handleReloadTable}
          >
            <Icon type="reload" />
          </ButtonStandard>
          <ButtonStandard
            type="button"
            disabled={!isAllowedFunctions(["PLUS_MENU_IMPORT_ANIMAL_COVERAGE"])}
            buttonType="addNew"
            onClick={() => dispatch(AppActions.showModalAnimalBirthUpload())}
          >
            {translation.imports.animalBirths.buttonImport}
          </ButtonStandard>
        </Col>
      </Row>
      <Row type="flex" justify="space-between">
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <Table
            loading={isLoading}
            rowKey="id"
            size="small"
            dataSource={
              importAnimalBirthLogData != null
                ? importAnimalBirthLogData.content
                : []
            }
            pagination={{
              total:
                importAnimalBirthLogData != null
                  ? importAnimalBirthLogData.totalElements
                  : 0,
              size:
                importAnimalBirthLogData != null
                  ? importAnimalBirthLogData.size
                  : 0,
              current:
                importAnimalBirthLogData != null
                  ? importAnimalBirthLogData.number + 1
                  : 0,
              hideOnSinglePage:
                importAnimalBirthLogData !== null &&
                Object.entries(importAnimalBirthLogData).length !== 0
                  ? importAnimalBirthLogData.totalElements > 10
                    ? false
                    : true
                  : true,
              showSizeChanger: true,
              pageSizeOptions: ["10", "20", "30", "100", "500", "1000", "2000"],
            }}
            scroll={{
              x: true,
            }}
            style={{ width: "100%", margin: "0" }}
            onChange={handleTableChange}
          >
            <Column
              title={translation.imports.animalBirths.table.columns.status}
              dataIndex="status"
              key="status"
              align="left"
              render={(status) =>
                status === "Processed" ? (
                  <TagStatus
                    background="#C5F1CA"
                    borderColor="#106518"
                    color="#106518"
                  >
                    {translation.imports.status.processed}
                  </TagStatus>
                ) : status === "Queue" ? (
                  <TagStatus
                    background="#EBF7FF"
                    borderColor="#4A85AE"
                    color="#4A85AE"
                  >
                    {translation.imports.status.queue}
                  </TagStatus>
                ) : status === "Processing" ? (
                  <TagStatus
                    background="#FEFFF6"
                    borderColor="#A9C133"
                    color="#A9C133"
                  >
                    {translation.imports.status.processing}
                  </TagStatus>
                ) : status === "Deleting" ? (
                  <TagStatus
                    background="#FFD8D8"
                    borderColor="#D44C4C"
                    color="#D44C4C"
                  >
                    {translation.imports.status.deleting}
                  </TagStatus>
                ) : (
                  <TagStatus
                    background="#FFD8D8"
                    borderColor="#D44C4C"
                    color="#D44C4C"
                  >
                    {translation.imports.status.error}
                  </TagStatus>
                )
              }
            />
            <Column
              title={translation.imports.animalBirths.table.columns.fileName}
              dataIndex="fileName"
              key="fileName"
              align="left"
              sorter
              sortDirections={["descend", "ascend"]}
            />
            <Column
              title={translation.imports.animalBirths.table.columns.date}
              dataIndex="date"
              align="left"
              key="date"
            />
            <Column
              title={translation.imports.animalBirths.table.columns.total}
              dataIndex="total"
              align="center"
              key="total"
            />
            <Column
              title={
                translation.imports.animalBirths.table.columns.numberImported
              }
              dataIndex="numberImported"
              align="center"
              key="numberImported"
            />
            <Column
              title={translation.imports.animalBirths.table.columns.numberError}
              dataIndex="numberError"
              align="center"
              key="numberError"
            />
            <Column
              title={
                translation.imports.animalBirths.table.columns.numberDuplicated
              }
              dataIndex="numberDuplicated"
              align="center"
              key="numberDuplicated"
            />
            <Column
              title={translation.imports.animalBirths.table.columns.message}
              dataIndex="message"
              align="left"
              key="message"
            />
            <Column
              align="left"
              render={(text, record) =>
                record.status === "Processed" ? (
                  <Link
                    to={`/admin/imports/animal/births/${record.requestId}/details`}
                  >
                    <EyeIcon isActive />
                  </Link>
                ) : null
              }
            />
          </Table>
        </Col>
      </Row>
    </CardCustom>
  );
}

export default AnimalBirthImport;
